export default "__VITE_ASSET__xV64Mq4G__"